import Divider from './src/Divider';
export default Divider;